export default __webpack_public_path__ + "static/media/food2.c0298f68.png";